const gbTrialBlue = {
  FORMS: [
    {
      type: 'trial-contact-form',
      name: 'TrialContactForm',
      message: {
        open: 'Formulario contacto',
        send: 'Envío Formulario De Contacto'
      }
    }],
  CSS: {
    id: '64b70956ff65839a402bb3dc',
    name: 'gb-trial-blue',
    avatar: {
      name: 'Chatbot',
      header: 'https://chatbotqa.gatblac.com/static/avatar/gatblac-trial/avatar-blue-close.png',
      new: 'https://chatbotqa.gatblac.com/static/avatar/gatblac-trial/avatar-blue-new.png',
      open: 'https://chatbotqa.gatblac.com/static/avatar/gatblac-trial/avatar-blue-open.png',
      close: 'https://chatbotqa.gatblac.com/static/avatar/gatblac-trial/avatar-blue-close.png'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#007BFF',
        borderColor: '#007BFF'
      }
    }
  }
}

export default gbTrialBlue
